var map = {
	"./1.jpg": 25666,
	"./10.jpg": 56208,
	"./11.jpg": 57133,
	"./12.jpg": 44226,
	"./13.jpg": 40543,
	"./14.jpg": 19732,
	"./15.jpg": 33457,
	"./16.jpg": 75686,
	"./17.jpg": 14211,
	"./18.jpg": 34360,
	"./19.jpg": 95541,
	"./2.jpg": 71597,
	"./20.jpg": 47713,
	"./21.jpg": 69668,
	"./22.jpg": 21299,
	"./23.jpg": 58134,
	"./3.jpg": 19376,
	"./4.jpg": 95651,
	"./5.jpg": 52518,
	"./6.jpg": 80273,
	"./7.jpg": 65940,
	"./8.jpg": 64999,
	"./9.jpg": 9162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63679;